import './solarcommercial'

export default angular
    .module('sySolarComCalculator', ['rzModule'])
    .config([
        '$locationProvider',
        function ($locationProvider) {
            $locationProvider
                .html5Mode({
                    enabled: true,
                    requireBase: false,
                    rewriteLinks: false
                })
                .hashPrefix('')
        }
    ])
    .factory('SolarCalculatorHousehold', [
        '$http',
        function SolarCalculatorHousehold($http) {
            return {
                getHouseholdData: function () {
                    return $http.post('/Solar/GetHouseholdSavingsPerYear')
                }
            }
        }
    ])

    .factory('SolarCalculatorParameters', function SolarCalculatorParameters() {
        return {
            encode: function (params) {
                Object.keys(params).forEach(function (key) {
                    if (params[key] === '' || params[key] === undefined) {
                        delete params[key]
                    }
                })

                return Object.keys(params)
                    .map(function (k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
                    })
                    .join('&')
            }
        }
    })

    /**
     * @ngdoc service
     * @name syTtoc.service:SolarComService
     * @description
     * Creates a service that handles cookies , 15 minutes expiry by default
     */
    // @ngInject
    .service('SolarComService', [
        '$cookies',
        function SolarComService($cookies) {
            var cookieNamespace = 'synergy.src.calcclicked'
            var cookieBusinessHours = 'synergy.src.businesshours'
            var cookieDaysOpen = 'synergy.src.daysopen'
            var cookieIndustry = 'synergy.src.industry'
            var cookieDispMsg = 'synergy.src.dispmsg'

            this.setCookieByName = function (cookieName, value) {
                // Build the cookie value
                var date = new Date(new Date().getTime() + 900000)
                var data = value + '|' + date
                // TODO: Put default path in config
                $cookies.put(cookieName, data, { path: '' })
            }

            this.getCookieByName = function (cookieName) {
                var raw = $cookies.get(cookieName)
                if (!raw) {
                    return null
                }

                var array = raw.split('|')
                if (array.length !== 2) {
                    return null
                }

                var data = array[0]
                var date = new Date(array[1])
                var currentDate = new Date()

                return date < currentDate ? null : data
            }

            this.clearCookieByName = function (cookieName) {
                $cookies.remove(cookieName)
            }

            // Gets the if button is clicked is stored in the cookies.
            this.getCalcClickedFromCookie = function () {
                return this.getCookieByName(cookieNamespace)
            }

            // Sets 15 minutes expiry.
            this.setCaclcClickedInCookie = function (v) {
                this.setCookieByName(cookieNamespace, v)
            }

            // Clear the  stored in the cookies
            this.clearCalcClickedCookie = function () {
                $cookies.remove(cookieNamespace)
            }

            this.setBusinessHourCookie = function (v) {
                this.setCookieByName(cookieBusinessHours, v)
            }

            this.getBusinessHourCookie = function () {
                return this.getCookieByName(cookieBusinessHours)
            }

            this.clearBussinessHourCookie = function () {
                $cookies.remove(cookieBusinessHours)
            }

            this.setDaysOpenCookie = function (v) {
                this.setCookieByName(cookieDaysOpen, v)
            }
            this.getDaysOpenCookie = function () {
                return this.getCookieByName(cookieDaysOpen)
            }

            this.clearDaysOpenCookie = function () {
                $cookies.remove(cookieDaysOpen)
            }

            this.setIndustryCookie = function (v) {
                this.setCookieByName(cookieIndustry, v)
            }

            this.getIndustryCookie = function () {
                return this.getCookieByName(cookieIndustry)
            }

            this.clearIndustryCookie = function () {
                $cookies.remove(cookieIndustry)
            }

            this.setDispMsgCookie = function (v) {
                this.setCookieByName(cookieDispMsg, v)
            }

            this.getDispMsgCookie = function () {
                return this.getCookieByName(cookieDispMsg)
            }
        }
    ])
    // Animation slider service
    .service('SliderService', function SliderService() {
        this.slideUpTransition = function ($el) {
            $el.css('max-height', '0')
            $el.addClass('height-transition-hidden')
        }

        this.slideDownTransition = function ($el) {
            $el.removeClass('height-transition-hidden')

            // Temporarily make visible to get the size
            $el.css('max-height', 'none')
            var height = '2600px'

            // Reset to 0 then animate with small delay
            $el.css('max-height', '0')

            setTimeout(function () {
                $el.css({
                    'max-height': height
                })
            }, 1)
        }
    })
    .controller('SolarComCalculatorController', [
        '$scope',
        '$timeout',
        'SolarComService',
        '$anchorScroll',
        '$location',
        function SolarComCalculatorController($scope, $timeout, SolarComService, $anchorScroll, $location) {
            this.formName = 'mySolarComCalculator'
            this.method = 'POST'
            this.apiURL = 'https://selfserve.synergy.net.au/apps/json/solarEnquiry/launchSolarEnquiryForm'
            this.redirectURL = 'https://selfserve.synergy.net.au/solar-enquiry.html'
            this.consultantName = ''
            this.errors = {}

            $scope.submitted = false

            $scope.interacted = function (field) {
                return $scope.submitted || field.$dirty
            }
            $scope.interactedInvalidAddress = function (field) {
                if (field.$modelValue) {
                    if (field.$modelValue.length >= 3) {
                        return $scope.submitted || field.$dirty
                    }
                }
            }

            $scope.industry = ''

            $scope.businesHoursSlider = {
                value: 0,
                options: {
                    floor: 0,
                    ceil: 2,
                    showSelectionBar: true,
                    hideLimitLabels: true,
                    showTicksValues: true,
                    stepsArray: 'Day,Night,24 Hours'.split(',')
                }
            }

            $scope.daysOpenSlider = {
                value: 1,
                options: {
                    floor: 1,
                    ceil: 7,
                    showSelectionBar: true,
                    hideLimitLabels: true,
                    showTicksValues: true
                }
            }

            $scope.display_message = ''

            $scope.scrolltoForm = function () {
                // Set the location.hash to the id of
                // The element you wish to scroll to.
                $location.hash('battery')
                // Call $anchorScroll()
                $anchorScroll.yOffset = 50
                $anchorScroll()
            }

            $scope.GetYourSolarFactor = function (form) {
                // Set the location.hash to the id of
                // The element you wish to scroll to.
                $location.hash('solarReturnFactor')
                // Call $anchorScroll()
                $anchorScroll.yOffset = 250
                $anchorScroll()
                $scope.hasErrors = false
                //Check if form is valid
                if (form && !form.$valid) {
                    form.businessIndustry.$setDirty()
                    $scope.hasErrors = true
                    $scope.$apply()
                    return false
                }

                $scope.display_message = calculateFactor()

                // Set cookie that user has clicked
                SolarComService.setCaclcClickedInCookie('clicked')
                SolarComService.setBusinessHourCookie($scope.businesHoursSlider.value)
                SolarComService.setDaysOpenCookie($scope.daysOpenSlider.value)
                SolarComService.setIndustryCookie($scope.industry)
                SolarComService.setDispMsgCookie($scope.display_message)
            }

            $scope.industries = [
                'Agribusiness',
                'Communications',
                'Education',
                'Food & Beverage',
                'Government',
                'Healthcare & Aged',
                'Hospitality',
                'Local government',
                'Mining',
                'Motor',
                'Manufacturing',
                'Recreation',
                'Retail',
                'Services & Property',
                'Storage',
                'Transport',
                'Utilities',
                'Other'
            ]

            // Great = 0, medium =1, low = 2
            var calculateFactor = function () {
                if ($scope.industry === '' || $scope.industry === null) {
                    return ''
                }
                var possibleOutComes =
                [
                    { industry: $scope.industries, businessHours: 0, daysOpen: [1, 2, 3, 4, 5, 6, 7], result: 'High' },
                    { industry: $scope.industries, businessHours: 1, daysOpen: [1, 2, 3, 4, 5, 6, 7], result: 'Low' },
                    { industry: $scope.industries, businessHours: 2, daysOpen: [1, 2, 3, 4, 5, 6, 7], result: 'High' }
                ]

                var result = 'Not Matched'

                $scope.daysOpenSlider.value = $scope.daysOpenSlider.value === 0 ? 1 : $scope.daysOpenSlider.value
                angular.forEach(possibleOutComes, function (o, k) {
                    if (
                        o.industry.indexOf($scope.industry) !== -1
                        && $scope.businesHoursSlider.value === o.businessHours
                        && o.daysOpen[$scope.daysOpenSlider.value - 1] === $scope.daysOpenSlider.value                        
                    )
                    {
                        result = o.result
                    }
                })
                return result
            }

            $scope.calculatorShow = false
            $scope.hideCalculator = function () {
                // Hide full calculator box
                $scope.showCollapsedMessage()
                $scope.calculatorShow = false
            }

            $scope.showCalculator = function () {
                $scope.businesHoursSlider.value = SolarComService.getBusinessHourCookie()
                $scope.daysOpenSlider.value = SolarComService.getDaysOpenCookie()
                $scope.industry = SolarComService.getIndustryCookie()
                $scope.display_message = SolarComService.getDispMsgCookie()

                $scope.calculatorShow = true
                $scope.collapsed = false
                //$scope.GetYourSolarFactor()
            }

            $scope.collapsed = false
            $scope.showCollapsedMessage = function () {
                var c = SolarComService.getCalcClickedFromCookie()
                if (c != null && c != 'undefined') {
                    $scope.collapsed = true
                    $scope.calculatorShow = false
                } else {
                    $scope.collapsed = false
                    $scope.calculatorShow = true
                    $scope.businesHoursSlider.value = SolarComService.getBusinessHourCookie()
                    $scope.daysOpenSlider.value = SolarComService.getDaysOpenCookie()
                    $scope.industry = SolarComService.getIndustryCookie()
                }
            }

            $scope.showCollapsedMessage()

            $scope.refreshSlider = function () {
                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender')
                })
            }

            $scope.callUs = function () {
                // Return AnalyticsService.trackEvent('User Interaction', 'Click Call Us', 'Solar Calculator');
            }
        }
    ])

    .controller('SolarBatteryController', [
        '$scope',
        '$http',
        'SolarComService',
        '$rootScope',
        function SolarBatteryController($scope, $http, SolarComService, $rootScope) {
            var processing = false

            $scope.data = {}
            $scope.data.errorCode = ''
            $scope.data.interestedIn = ''
            $scope.data.isFroniusInverter = ''
            $scope.data.solarPurchaseSource = ''
            $scope.data.search = ''
            $scope.data.postalCode = ''
            $scope.data.city = ''
            $scope.data.street = ''
            $scope.data.searchCityPlaceHolder = ''
            $scope.data.searchPostcodePlaceHolder = ''
            $scope.data.leadSource = ''
            $scope.data.isSolarFinance = '0'
            $scope.data.goalId = ''
            $scope.actionURL = '/Contact/SolarBatterySave'
            $scope.data.FormSubmitted = $scope.data.FormIsValid = false

            $scope.isProcessing = function () {
                return processing
            }

            $scope.showHowCanWeHelp = function () {
                const { interestedIn, solarPurchaseSource, enclosedGarage } = $scope.data
                var show = false
                switch (interestedIn) {
                    case 'Solar':
                        show = true
                        break
                    case 'Battery':
                        if (solarPurchaseSource === 'from us' && enclosedGarage !== '0') {
                            show = true
                        }
                        break
                    case 'Solar + Battery':
                        show = true
                        break
                    default:
                        break
                }
                return show
            }

            $scope.showIsFroniusInverter = function () {
                const { interestedIn, solarPurchaseSource } = $scope.data
                return interestedIn === 'Battery' && solarPurchaseSource === 'from somebody else'
            }

            $scope.showPurchaseFrom = function () {
                return $scope.data.interestedIn === 'Battery'
            }

            $scope.showEnclosedGarage = function () {
                const { interestedIn, solarPurchaseSource } = $scope.data
                var result = true
                if (
                    interestedIn === '' ||
                    interestedIn === 'Solar' ||
                    solarPurchaseSource === 'from somebody else' ||
                    solarPurchaseSource === 'i dont have solar'
                ) {
                    result = false
                }
                if (interestedIn === 'Battery' && solarPurchaseSource === 'from us') {
                    result = true
                }
                return result
            }

            $scope.showContactusDetail = function () {
                var show = false
                const { interestedIn, isFroniusInverter, solarPurchaseSource } = $scope.data

                if (
                    interestedIn === 'Solar' ||
                    interestedIn === 'Solar + Battery' ||
                    isFroniusInverter ||
                    solarPurchaseSource === 'from us' ||
                    solarPurchaseSource === 'i dont have solar'
                ) {
                    show = true
                }

                if (interestedIn === 'Solar + Battery') {
                    solarPurchaseSource = ''
                }
                return show
            }

            $scope.showRegisterInterestText = function () {
                var show = false
                const { interestedIn, enclosedGarage, isFroniusInverter, solarPurchaseSource } = $scope.data

                if (interestedIn === 'Battery' && solarPurchaseSource === 'from us' && enclosedGarage === '0') {
                    show = true
                } else if (
                    (interestedIn === 'Battery' &&
                        solarPurchaseSource === 'from somebody else' &&
                        isFroniusInverter === 'No') ||
                    solarPurchaseSource === 'i dont have solar'
                ) {
                    show = true
                }
                return show
            }

            $scope.showRegisterInterestTextSolarBattery = function () {
                var show = false
                const { interestedIn, enclosedGarage, isFroniusInverter, solarPurchaseSource } = $scope.data

                if (interestedIn === 'Battery' && solarPurchaseSource === 'from us' && enclosedGarage === '1') {
                    show = true
                } else if (interestedIn === 'Battery' && solarPurchaseSource === 'from us' && enclosedGarage === '') {
                    show = false
                } else if (interestedIn === 'Solar + Battery' && (enclosedGarage === '0' || enclosedGarage === '1')) {
                    show = true
                } else if (
                    interestedIn === 'Battery' &&
                    solarPurchaseSource === 'from somebody else' &&
                    isFroniusInverter === 'Yes'
                ) {
                    show = true
                } else if (interestedIn === 'Solar') {
                    show = true
                }
                return show
            }

            $scope.isShowConfirmationPage = function () {
                return $scope.data.FormSubmitted && $scope.data.FormIsValid
            }

            $scope.isEoiOnly = function () {
                const { interestedIn, enclosedGarage, isFroniusInverter, solarPurchaseSource } = $scope.data

                if (interestedIn === 'Solar + Battery' || interestedIn === 'Solar') {
                    return false
                }
                if (solarPurchaseSource === 'from us' && enclosedGarage === '0') {
                    return true
                } else if (
                    ((isFroniusInverter === '' || isFroniusInverter === 'No') &&
                        solarPurchaseSource == 'from somebody else') ||
                    solarPurchaseSource === 'i dont have solar'
                ) {
                    return true
                }
                return false
            }

            $scope.splitSapAddress = function (address) {
                var splitted = address.trim().split(' ')
                var splittedAddress = {}

                splittedAddress.city = splitted[splitted.length - 4]
                var postcode = splitted[splitted.length - 3]

                splittedAddress.street = splitted.slice(0, splitted.length - 4).join(' ')
                if (stringIsNumber(postcode) && postcode.length >= 4 && postcode.length <= 6) {
                    splittedAddress.postalCode = postcode
                } else {
                    splittedAddress.street = address.trim()
                    splittedAddress.city = ''
                }
                return splittedAddress
            }

            function stringIsNumber(s) {
                var x = Number(s) // Made cast obvious for demonstration
                return x.toString() === s
            }

            $scope.isAddressRequired = function () {
                if (!angular.isUndefined($rootScope.installationAddress) && $rootScope.installationAddress.length > 0) {
                    return false
                }
                return true
            }

            $scope.submit = function (SolarBattery) {
                if (SolarBattery.$invalid) {
                    return
                }
                $scope.button = {}
                $scope.button.disabled = true

                var params = angular.copy($scope.data)

                var addressRequired = true

                if ($scope.isEoiOnly()) {
                    addressRequired = false
                    params.connectionAddress = ''
                    params.ConnectionAddress = ''
                    params.howCanWeHelpYou = ''
                    params.phoneNumber = ''
                    params.mobileNumber = ''
                    params.preferredTimeframe = ''
                    params.symoModel = ''
                    params.preferredContact = ''
                }

                if ($scope.showRegisterInterestText()) {
                    addressRequired = false
                    params.connectionAddress = ''
                    params.ConnectionAddress = ''
                    params.howCanWeHelpYou = ''
                }

                if ($scope.data.interestedIn == 'Solar + Battery' || $scope.data.interestedIn == 'Solar') {
                    params.solarPurchaseSource = ''
                    params.isFroniusInverter = ''
                }
                if ($scope.data.solarPurchaseSource == 'from us') {
                    params.isFroniusInverter = ''
                }

                var config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                    }
                }

                if (angular.isUndefined(params.street)) {
                    params.street = '-1'
                }

                if (
                    addressRequired &&
                    (angular.isUndefined(params.connectionAddress) || params.connectionAddress == '')
                ) {
                    // Get from cookies
                    if (angular.isUndefined($rootScope.completeAddress)) {
                        var add = angular.fromJson(SolarComService.getCookieByName('complete_address'))

                        if (add != null) {
                            angular.merge(params, add)
                        }
                        if (!angular.isUndefined($scope.searchAddressPaceholder)) {
                            params.connectionAddress = $scope.searchAddressPaceholder
                        }
                    } else {
                        angular.merge(params, $rootScope.completeAddress)
                    }
                } else if (
                    addressRequired &&
                    !angular.isUndefined(params.connectionAddress) &&
                    params.connectionAddress.indexOf(params.street) < 0
                ) {
                    // Split SAP address result into appropriate values
                    angular.merge(params, $scope.splitSapAddress(params.connectionAddress))
                }

                if (params.street === '-1') {
                    params.street = ''
                }

                if (!params.connectionAddress) {
                    params.connectionAddress = params.street + ' ' + params.city + ' ' + params.postalCode
                }

                // Get results from calculator
                var ro = angular.fromJson(SolarComService.getCookieByName('sy_solar_battery_result'))

                if (ro !== null) {
                    ro.totalSavings = ro.totalSavings.replace('$', '')
                    ro.SavingsPerYear = ro.SavingsPerYear.replace('$', '')
                    ro.BatterySavingsPerYear = ro.BatterySavingsPerYear.replace('$', '')

                    angular.merge(params, ro)
                }

                Object.keys(params).forEach(function (key) {
                    if (params[key] == '' || params[key] == undefined) {
                        delete params[key]
                    }
                })

                var params = Object.keys(params)
                    .map(function (k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
                    })
                    .join('&')

                processing = true
                $http.post($scope.actionURL, params, config).then(
                    function (response) {
                        processing = false
                        $scope.data = response.data.Data
                    },
                    function (response) {
                        processing = false
                        $scope.result = response.data
                    }
                )
            }

            $scope.$watch(
                function () {
                    return $rootScope.installationAddress
                },
                function () {
                    $scope.data.connectionAddress = $rootScope.installationAddress
                }
            )

            $scope.$watch(
                function () {
                    return $rootScope.emailAddress
                },
                function () {
                    if ($rootScope.emailAddress) {
                        $scope.data.email = $rootScope.emailAddress
                    }
                }
            )
        }
    ])

    .directive('predictiveSearchFillInputSplit', [
        '$timeout',
        function predictiveSearchFillInputSplit($timeout) {
            return {
                require: '^predictiveSearch',
                link: function ($scope, $element, attrs) {
                    var fillValue = attrs.predictiveSearchFillInputSplit
                    $element.on('click', function (e) {
                        $timeout(function () {
                            $scope.controller.search = $scope.data.search = fillValue
                            var splitSapAddress = $scope.splitSapAddress(fillValue)
                            $scope.data.street = splitSapAddress.street
                            $scope.data.city = splitSapAddress.city
                            $scope.data.postalCode = splitSapAddress.postalCode
                            angular
                                .element(document.querySelector('.predictive-search--active'))
                                .removeClass('predictive-search--active')
                        })
                        e.preventDefault()
                    })
                }
            }
        }
    ])

    .directive('validateMobileLandline', [
        '$q',
        function validateMobileLandline($q) {
            return {
                require: 'ngModel',
                link: function ($scope, $element, attrs, ngModel) {
                    var filterSpaces = function (str) {
                        return str.replace(/[\s()]/g, '')
                    }

                    var zeroPad = function (num) {
                        if (
                            num.toString().length == 9 &&
                            num.toString().indexOf('0') !== 0 &&
                            num.toString().trim() != '' &&
                            (num.toString().charAt(0) === '4' ||
                                num.toString().charAt(0) === '5' ||
                                num.toString().charAt(0) === '2' ||
                                num.toString().charAt(0) === '3' ||
                                num.toString().charAt(0) === '7' ||
                                num.toString().charAt(0) === '8')
                        ) {
                            num = '0' + num.replace(/[\s]/g, '')
                        }
                        return num
                    }
                    var checkPhone = function (num) {
                        if (
                            num.toString().length == 8 &&
                            num.toString().indexOf('0') !== 0 &&
                            num.toString().trim() != '' &&
                            (num.toString().charAt(0) === '6' || num.toString().charAt(0) === '9')
                        ) {
                            return true
                        }

                        return false
                    }

                    var validateno = function (viewValue) {
                        viewValue = filterSpaces(viewValue)
                        if (!checkPhone(viewValue)) {
                            viewValue = zeroPad(viewValue)
                            $element.val(viewValue)
                            if (/^(04|05)[\d]{8}$/.test(viewValue)) {
                                $scope.data.preferredContact = 'Mobile'
                                $scope.data.mobileNumber = viewValue
                                $scope.data.phoneNumber = ''
                                $scope.data.phonePrefix = ''
                                return true
                            } else if (/^(02|03|07|08)[\d]{8}$/.test(viewValue)) {
                                $scope.data.preferredContact = 'Phone'
                                $scope.data.phoneNumber = viewValue
                                $scope.data.phonePrefix = ''
                                $scope.data.mobileNumber = ''
                                return true
                            }

                            return false
                        }
                    }
                    $element.bind('blur', function () {
                        ngModel.$viewValue = filterSpaces(ngModel.$viewValue)
                        $element.val(ngModel.$viewValue)

                        ngModel.$setViewValue(ngModel.$viewValue)
                        var isValidateNo = validateno(ngModel.$viewValue)
                        $scope.$apply(function () {
                            ngModel.$setValidity('validateNo', isValidateNo)
                        })
                    })

                    ngModel.$asyncValidators.validatePhone = function (modelValue, viewValue) {
                        var deferred = $q.defer()
                        viewValue = filterSpaces(viewValue)
                        if (checkPhone(viewValue)) {
                            deferred.reject()
                        } else {
                            ngModel.$viewValue = filterSpaces(ngModel.$viewValue)
                            $element.val(ngModel.$viewValue)

                            ngModel.$setViewValue(ngModel.$viewValue)
                            var isValidateNo = validateno(ngModel.$viewValue)
                            deferred.resolve()
                        }
                        return deferred.promise
                    }
                }
            }
        }
    ])

    .controller('SolarMapController', [
        '$scope',
        'SolarCalculatorHousehold',
        '$http',
        '$timeout',
        '$filter',
        '$window',
        '$location',
        'SolarComService',
        '$rootScope',
        'SliderService',
        function SolarMapController(
            $scope,
            SolarCalculatorHousehold,
            $http,
            $timeout,
            $filter,
            $window,
            $location,
            SolarComService,
            $rootScope,
            SliderService
        ) {
            $scope.data = {}
            $scope.data.showStreetView = false
            $scope.checkedTab = 'solarpv'
            $scope.clickedEmail = false
            $scope.LGTabClicked = true
            $scope.FroniusTabClicked = false
            $scope.omnitureStep = '1'

            var map // Need it
            var sv = new google.maps.StreetViewService()
            var geocoder = new google.maps.Geocoder()
            var directionsService = new google.maps.DirectionsService()
            var panorama
            var myLatLng

            var input = document.getElementById('pac-input')
            var searchButton = input.querySelector('#search-submit-button')
            // Search box
            var inputField = input.querySelector('#address-search-field')
            var searchBox = new google.maps.places.SearchBox(inputField)
            var autocomplete = new google.maps.places.Autocomplete(inputField)

            var geocoder = new google.maps.Geocoder()
            var perth = {
                lat: -31.949772,
                lng: 115.772961
            }
            var lastSearchCenter = angular.fromJson(SolarComService.getCookieByName('latlng'))
            var zoom = lastSearchCenter != null ? 20 : 12
            /**
             * The CenterControl adds a control to the map that recenters the map on
             * Perth.
             * This constructor takes the control DIV as an argument.
             *
             */

            $scope.mapTypeId =
                lastSearchCenter != null ? google.maps.MapTypeId.SATELLITE : google.maps.MapTypeId.ROADMAP
            var mapOptions = {
                zoom: zoom,
                center: lastSearchCenter != null ? lastSearchCenter : perth,
                disableDefaultUI: true,
                mapTypeId: $scope.mapTypeId
            }

            // Start with Normal View
            var initAutocomplete = function () {
                const mapElement = document.getElementById('map-battery')
                if (mapElement) {
                    map = new google.maps.Map(mapElement, mapOptions)
                    autocomplete.bindTo('bounds', map)

                    // Add click event on search button
                    searchButton.addEventListener('click', function () {
                        placeChanged(searchBox, map)
                    })

                    // Place changed event
                    autocomplete.addListener('place_changed', function () {
                        placeChanged(searchBox, map)
                    })
                }
            }

            var placeChanged = function () {
                var place = autocomplete.getPlace()

                if (angular.isUndefined(place) || !place.geometry) {
                    // User entered the name of a Place that was not suggested and
                    // Pressed the Enter key, or the Place Details request failed.
                    // Window.alert("No details available for input: '" + place.name + "'");
                    return
                }

                var address = ''
                if (place.address_components) {
                    address = [
                        (place.address_components[0] && place.address_components[0].short_name) || '',
                        (place.address_components[1] && place.address_components[1].short_name) || '',
                        (place.address_components[2] && place.address_components[2].short_name) || ''
                    ].join(' ')

                    $scope.data.installationAddress = place.formatted_address
                    $rootScope.installationAddress = place.formatted_address

                    var subpremise = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'subpremise') {
                            return o
                        }
                    })[0]

                    var postalCode = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'postal_code') {
                            return o
                        }
                    })[0]

                    if (postalCode) {
                        $scope.data.SuburbExtract = postalCode.short_name
                    }

                    var street_number = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'street_number') {
                            return o
                        }
                    })[0]

                    var route = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'route') {
                            return o
                        }
                    })[0]

                    var locality = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'locality') {
                            return o
                        }
                    })[0]

                    var administrative_area_level_1 = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'administrative_area_level_1') {
                            return o
                        }
                    })[0]

                    var country = place.address_components.filter(function (o) {
                        if (o.types && o.types[0] == 'country') {
                            return o
                        }
                    })[0]

                    var street = subpremise ? subpremise.short_name + '/' : ''
                    street += street_number ? street_number.short_name : ''
                    street += ' '
                    street += route ? route.short_name : ''

                    $rootScope.completeAddress = {
                        street: street,
                        city: locality ? locality.short_name : '',
                        state: administrative_area_level_1 ? administrative_area_level_1.short_name : '',
                        country: country ? country.short_name : '',
                        postalCode: postalCode ? postalCode.short_name : ''
                    }

                    SolarComService.setCookieByName('complete_address', angular.toJson($rootScope.completeAddress))
                }
                // Load map
                reloacteByGeocoder(address, place)
            }

            function updateLatLngCookies(myLatLng) {
                var latlng = {
                    lat: myLatLng.lat(),
                    lng: myLatLng.lng()
                }
                SolarComService.setCookieByName('latlng', angular.toJson(latlng))
            }

            function reloacteByGeocoder(address) {
                geocoder.geocode(
                    {
                        address: address
                    },
                    function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            myLatLng = results[0].geometry.location

                            updateLatLngCookies(myLatLng)

                            map.setCenter(myLatLng)
                            // Find a Streetview location on the road
                            var request = {
                                origin: address,
                                destination: address,
                                travelMode: google.maps.DirectionsTravelMode.DRIVING
                            }
                            directionsService.route(request, directionsCallback)

                            if ($scope.data.showStreetView) {
                                createStreetMap()
                            } else {
                                createSattliteMap(status)
                            }
                        } else {
                            alert('Geocode was not successful for the following reason: ' + status)
                        }
                    }
                )
            }

            function createSattliteMap(place) {
                map.setTilt(45)

                map.setOptions({
                    mapTypeId: 'satellite',
                    zoom: 20
                })

                var bounds = new google.maps.LatLngBounds()
                if (place.geometry && place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport)
                } else if (place.geometry) {
                    bounds.extend(place.geometry.location)
                }

                // If the place has a geometry, then present it on a map.
                if (place.geometry && place.geometry.viewport) {
                    map.fitBounds(bounds)
                }

                var maxZoomService = new google.maps.MaxZoomService()
                maxZoomService.getMaxZoomAtLatLng(map.getCenter(), function () {
                    mapCenterForBigScreens(map, place)
                })
            }

            function mapCenterForBigScreens(map, place) {
                var wi = $window.innerWidth
                if (wi > 1139) {
                    if (place.geometry) {
                        map_recenter(place.geometry.location, (wi - 900) / 4 + wi / 4, 0)

                        var listener = google.maps.event.addListener(map, 'idle', function () {
                            map.setZoom(response)
                            google.maps.event.removeListener(listener)
                        })
                    }
                }
            }

            function map_recenter(latlng, offsetx, offsety) {
                var point1 = map
                    .getProjection()
                    .fromLatLngToPoint(latlng instanceof google.maps.LatLng ? latlng : map.getCenter())
                var point2 = new google.maps.Point(
                    (typeof offsetx == 'number' ? offsetx : 0) / Math.pow(2, map.getZoom()) || 0,
                    (typeof offsety == 'number' ? offsety : 0) / Math.pow(2, map.getZoom()) || 0
                )
                map.setCenter(
                    map
                        .getProjection()
                        .fromPointToLatLng(new google.maps.Point(point1.x - point2.x, point1.y + point2.y))
                )
            }

            function processSVData(data, status) {
                if (status == google.maps.StreetViewStatus.OK && panorama) {
                    panorama.setPano(data.location.pano)

                    var heading = google.maps.geometry.spherical.computeHeading(data.location.latLng, myLatLng)
                    panorama.setPov({
                        heading: heading - 25.0,
                        pitch: 3,
                        zoom: 1
                    })
                    panorama.setVisible(true)
                } 
            }

            function directionsCallback(response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    var latlng = response.routes[0].legs[0].start_location

                    map.setCenter(latlng)

                    sv.getPanoramaByLocation(latlng, 50, processSVData)
                }
            }

            $scope.getPOV = function () {
                getPOV()
            }
            function getPOV() {
                var pov = panorama.getPov()
                var posn = panorama.getPosition()
                var htmlStr =
                    'latlng=' +
                    posn.toUrlValue(6) +
                    '<br>heading=' +
                    pov.heading +
                    '<br>pitch=' +
                    pov.pitch +
                    '<br>zoom=' +
                    pov.zoom
                document.getElementById('streetview_pov').innerHTML = htmlStr
            }

            function createStreetMap() {
                var panoramaOptions = {
                    disableDefaultUI: true
                }

                const mapElement = document.getElementById('map-battery')
                if (mapElement) {
                    panorama = new google.maps.StreetViewPanorama(mapElement, panoramaOptions)

                    sv.getPanoramaByLocation(myLatLng, 50, processSVData)
                    // GetPanoramaByLocation will return the nearest pano when the
                    // Given radius is 50 meters or less.
                    google.maps.event.addListener(map, 'click', function (event) {
                        sv.getPanoramaByLocation(event.latLng, 50, processSVData)
                    })
                }
            }

            // Take care of first page load..
            initAutocomplete()

            /********************* Map should end here...**************************/
            $scope.systemSizeValues = []
            $scope.LGSystemSizeValues = []
            $scope.FroniusSystemSizeValues = []
            $scope.slider = {
                value: 1.5,
                options: {
                    floor: 1,
                    ceil: 5,
                    showSelectionBar: true,
                    precision: 0.5,
                    hideLimitLabels: true
                }
            }

            $scope.batterySlider = {
                value: 0,
                options: {
                    floor: 0,
                    ceil: 5,
                    showSelectionBar: true,
                    precision: 0.5,
                    hideLimitLabels: true
                }
            }

            var batterySystemSizeValues = [4.5, 6, 7.5, 9, 10.5, 12]
            var airConHours = [1.2, 1.6, 2, 2.4, 2.8, 3.2]
            batterySystemSizeValues.sort(function (a, b) {
                return a - b
            })

            $scope.batterySlider.options.stepsArray = batterySystemSizeValues.map(function (v) {
                return v + 'kW'
            })

            $scope.batterySlider.value = 0
            $scope.selecteAirConHours = airConHours[$scope.batterySlider.value]

            $scope.refreshSlider = function () {
                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender')
                })
            }

            $scope.interacted = function (field) {
                return $scope.submitted || field.$dirty
            }

            var addAmount = function (no1, no2) {
                var dollars =
                    parseInt(no1.replace('$', '').replace(',', '')) + parseInt(no2.replace('$', '').replace(',', ''))
                return $filter('currency')(dollars, '$', 0)
            }
            $scope.ctrl.solarSystemSize
            $scope.BatterySystemSize
            $scope.ctrl.LGSystemSize
            $scope.ctrl.FroniusSystemSize
            $scope.showBattery = false
            $scope.addBattery = false

            var updateSliders = function () {
                $scope.systemSizeValues.sort(function (a, b) {
                    return a - b
                })
                $scope.LGSystemSizeValues.sort(function (a, b) {
                    return a - b
                })
                $scope.FroniusSystemSizeValues.sort(function (a, b) {
                    return a - b
                })
                $scope.ctrl.solarSystemSize = $scope.systemSizeValues[0]
                $scope.BatterySystemSize = $scope.ctrl.LGSystemSize = $scope.LGSystemSizeValues[0]
                $scope.ctrl.FroniusSystemSize = $scope.FroniusSystemSizeValues[0]
            }

            var updateResultInCookies = function () {
                var str = angular.toJson($scope.result)
                SolarComService.setCookieByName('sy_solar_battery_result', str)
                var data = {
                    installationAddress: $scope.data.installationAddress,
                    SuburbExtract: $scope.data.SuburbExtract,
                    HouseholdSize: $scope.data.HouseholdSize,
                    resultEmail: $scope.resultEmail
                }

                $rootScope.installationAddress = $scope.data.installationAddress
                SolarComService.setCookieByName('sy_solar_battery_data', angular.toJson(data))
                if ($rootScope.completeAddress) {
                    SolarComService.setCookieByName('complete_address', angular.toJson($rootScope.completeAddress))
                }
            }

            var getResultFromCookies = function () {
                var str = SolarComService.getCookieByName('sy_solar_battery_result')
                return angular.fromJson(str)
            }

            var getDataFromCookies = function () {
                var str = SolarComService.getCookieByName('sy_solar_battery_data')
                return angular.fromJson(str)
            }

            // Display floating result and hide everything else..
            $scope.displayFloatingResultOnStart = function () {
                var jsonResults = getResultFromCookies()
                var jsonData = getDataFromCookies()
                var jsonCompleteAddress = angular.fromJson(SolarComService.getCookieByName('complete_address'))

                if (jsonCompleteAddress != null) {
                    $rootScope.completeAddress = jsonCompleteAddress
                }

                if (jsonResults == null) {
                    dc = angular.element(document.querySelector('#Map_field_container'))
                    SliderService.slideDownTransition(dc)
                    return
                }

                if (jsonResults.totalSavings && jsonResults.totalCost && jsonResults.KWHSystemBattery) {
                    $scope.result = jsonResults

                    if (jsonData != null) {
                        $scope.data = jsonData
                        $scope.data.noPeople = jsonData.HouseholdSize
                        $scope.data.installationAddress = $rootScope.installationAddress = jsonData.installationAddress
                        $rootScope.emailAddress = $scope.data.resultEmail = jsonData.resultEmail
                    }
                    $scope.submitted = true
                    var dc = angular.element(document.querySelector('#BCFloatingResult'))
                    SliderService.slideDownTransition(dc)

                    $timeout(function () {
                        $scope.getHouseHoldDataUpdateResults()
                    }, 100)
                }
            }

            $scope.displayFloatingResultOnStart()

            $scope.LGTabSelected = function () {
                $scope.checkedTab = 'LG'
                $scope.LGTabClicked = true
                $scope.fnLG($scope.ctrl.LGSystemSize)
                $scope.refreshSlider()
            }

            $scope.solarTabSelected = function () {
                $scope.checkedTab = 'solarpv'
                $scope.refreshSlider()
            }

            $scope.FroniusTabSelected = function () {
                $scope.FroniusTabClicked = true
                $scope.checkedTab = 'Enphase'
                $scope.fnFronius($scope.ctrl.FroniusSystemSize)
            }

            $scope.fnAddBattery = function () {
                $scope.addBattery = true
                var systemSize = $scope.ctrl.solarSystemSize >= 5 ? $scope.ctrl.solarSystemSize : 5
                $scope.onSolarChange(systemSize)
            }

            var findBatterySuggestion = function () {
                var defaultBatterySize = 7.5
                switch ($scope.result.KWSystem) {
                    case '1.5':
                    case '2':
                        defaultBatterySize = 7.5
                        break
                    case '3':
                        defaultBatterySize = 7.5
                        break
                    case '4':
                    case '5':
                        defaultBatterySize = 7.5
                        break
                    case '6':
                    case '7':
                        defaultBatterySize = 9
                        break
                    case '8':
                    case '9':
                        defaultBatterySize = 10.5
                        break
                    case '10':
                        defaultBatterySize = 12
                        break
                    default:
                        break
                }
                return defaultBatterySize
            }

            $scope.fnFronius = function (systemSize) {
                $scope.result.BatteryType = $scope.showBattery ? $scope.checkedTab : ''
                $scope.ctrl.FroniusSystemSize = systemSize
                $scope.selectedHouseholdDataForBattery = $filter('filter')($scope.data.householdData, {
                    KWSystem: systemSize,
                    SystemType: 'Enphase'
                })[0]
                $scope.result.KWHSystemBattery = $scope.selectedHouseholdDataForBattery.KWSystem
                $scope.result.BatteryEstimatedPriceRange = $scope.showBattery
                    ? $scope.selectedHouseholdDataForBattery.EstimatedPriceRange
                    : '0-0'
                $scope.result.BatterySavingsPerYear = $scope.showBattery
                    ? $scope.selectedHouseholdDataForBattery.SavingsPerYear
                    : '0'
                $scope.selecteAirConHours = $scope.selectedHouseholdDataForBattery.AirConHours
                $scope.result.Payback = $scope.showBattery
                    ? $scope.checkedTab == 'LG'
                        ? $scope.selectedHouseholdData.LGPayback
                        : $scope.selectedHouseholdDataForBattery.Payback
                    : $scope.selectedHouseholdData.Payback
                $scope.result.totalSavings = addAmount(
                    $scope.result.BatterySavingsPerYear,
                    $scope.result.SavingsPerYear
                )
                var solarArray = $scope.result.EstimatedPriceRange.split('-')
                var batteryArray = $scope.result.BatteryEstimatedPriceRange.split('-')
                $scope.result.totalCost =
                    '' + addAmount(solarArray[0], batteryArray[0]) + ' - ' + addAmount(solarArray[1], batteryArray[1])
                updateResultInCookies()
            }

            $scope.fnLG = function (systemSize) {
                $scope.result.BatteryType = $scope.showBattery ? $scope.checkedTab : ''
                $scope.ctrl.LGSystemSize = systemSize
                $scope.selectedHouseholdData = $filter('filter')($scope.data.householdData, {
                    KWSystem: $scope.ctrl.solarSystemSize,
                    SystemType: 'Solar'
                })[0]
                $scope.selectedHouseholdDataForBattery = $filter('filter')($scope.data.householdData, {
                    KWSystem: systemSize,
                    SystemType: 'LG'
                })[0]
                $scope.result.KWHSystemBattery = $scope.selectedHouseholdDataForBattery.KWSystem
                $scope.result.BatteryEstimatedPriceRange = $scope.showBattery
                    ? $scope.selectedHouseholdDataForBattery.EstimatedPriceRange
                    : '0-0'
                $scope.result.BatterySavingsPerYear = $scope.showBattery
                    ? $scope.selectedHouseholdDataForBattery.SavingsPerYear
                    : '0'
                $scope.selecteAirConHours = $scope.selectedHouseholdDataForBattery.AirConHours
                $scope.result.Payback = $scope.showBattery
                    ? $scope.checkedTab == 'LG'
                        ? $scope.selectedHouseholdData.LGPayback
                        : $scope.selectedHouseholdDataForBattery.Payback
                    : $scope.selectedHouseholdData.Payback
                $scope.result.totalSavings = addAmount(
                    $scope.result.BatterySavingsPerYear,
                    $scope.result.SavingsPerYear
                )
                var solarArray = $scope.result.EstimatedPriceRange.split('-')
                var batteryArray = $scope.result.BatteryEstimatedPriceRange.split('-')
                $scope.result.totalCost =
                    '' + addAmount(solarArray[0], batteryArray[0]) + ' - ' + addAmount(solarArray[1], batteryArray[1])
                updateResultInCookies()
            }
            $scope.hideBattery = function () {
                if ($scope.checkedTab === 'Enphase') {
                    $scope.fnFronius($scope.ctrl.FroniusSystemSize)
                } else {
                    $scope.fnLG($scope.ctrl.LGSystemSize)
                }
                $scope.showBattery = false
                $scope.addBattery = false
            }

            $scope.getHouseHoldDataUpdateResults = function () {
                var defaultkWSize = 1.5
                var defaultBatterySize = 10.5
                $scope.showBattery = false

                SolarCalculatorHousehold.getHouseholdData().then(
                    function (response) {
                        $scope.data.householdData = response.data

                        if ($scope.systemSizeValues.length <= 0) {
                            batterySystemSizeValues = []
                            airConHours = []

                            angular.forEach($scope.data.householdData, function (obj, key) {
                                if (obj.KWSystemInt > 0 && obj.SystemType == 'Solar') {
                                    $scope.systemSizeValues.push(obj.KWSystemInt)
                                } else if (obj.SystemType == 'LG') {
                                    $scope.LGSystemSizeValues.push(obj.KWSystemInt)
                                    batterySystemSizeValues.push(obj.KWSystemInt)
                                    airConHours.push(obj.AirConHours)
                                } else if (obj.SystemType == 'Fronius') {
                                    $scope.FroniusSystemSizeValues.push(obj.KWSystemInt)
                                    batterySystemSizeValues.push(obj.KWSystemInt)
                                    airConHours.push(obj.AirConHours)
                                } else if (obj.SystemType == 'Enphase') {
                                    $scope.FroniusSystemSizeValues.push(obj.KWSystemInt)
                                    batterySystemSizeValues.push(obj.KWSystemInt)
                                    airConHours.push(obj.AirConHours)
                                }
                            })

                            airConHours.sort(function (a, b) {
                                return a - b
                            })

                            // Update sliders with new values
                            updateSliders()
                            $scope.checkedTab = 'LG'
                            $scope.onSolarChange = function (systemSize) {
                                $scope.ctrl.solarSystemSize = systemSize
                                $scope.selectedHouseholdData = $filter('filter')($scope.data.householdData, {
                                    KWSystem: systemSize,
                                    SystemType: 'Solar'
                                })[0]
                                if (systemSize >= 5 && $scope.addBattery) {
                                    $scope.showBattery = true
                                    $scope.result.Payback =
                                        $scope.checkedTab == 'LG'
                                            ? $scope.selectedHouseholdData.LGPayback
                                            : $scope.selectedHouseholdDataForBattery.Payback
                                } else {
                                    $scope.addBattery = false
                                    $scope.showBattery = false
                                    $scope.result.Payback = $scope.selectedHouseholdData.Payback
                                }
                                $scope.result.BatteryType = $scope.showBattery ? $scope.checkedTab : ''
                                $scope.result.KWSystem = $scope.selectedHouseholdData.KWSystem
                                $scope.result.EstimatedPriceRange = $scope.selectedHouseholdData.EstimatedPriceRange
                                $scope.result.BatteryEstimatedPriceRange = $scope.showBattery
                                    ? $scope.selectedHouseholdDataForBattery.EstimatedPriceRange
                                    : '0-0'
                                $scope.result.PanelsNo = $scope.selectedHouseholdData.PanelsNo
                                $scope.result.PanelsNoInt = $scope.selectedHouseholdData.PanelsNoInt
                                $scope.result.RoofSpace = $scope.selectedHouseholdData.RoofSpace
                                $scope.result.SavingsPerYear = $scope.selectedHouseholdData.SavingsPerYear
                                $scope.result.BatterySavingsPerYear = $scope.showBattery
                                    ? $scope.result.BatterySavingsPerYear
                                    : '0'
                                $scope.result.totalSavings = addAmount(
                                    $scope.result.BatterySavingsPerYear,
                                    $scope.result.SavingsPerYear
                                )
                                var solarArray = $scope.result.EstimatedPriceRange.split('-')
                                var batteryArray = $scope.result.BatteryEstimatedPriceRange.split('-')
                                $scope.result.totalCost =
                                    '' +
                                    addAmount(solarArray[0], batteryArray[0]) +
                                    ' - ' +
                                    addAmount(solarArray[1], batteryArray[1])
                                $scope.ctrl.FroniusSystemSize = findBatterySuggestion()

                                if ($scope.checkedTab === 'Enphase') {
                                    $scope.fnFronius($scope.ctrl.FroniusSystemSize)
                                } else {
                                    $scope.fnLG($scope.ctrl.LGSystemSize)
                                }
                                updateResultInCookies()
                            }

                            $scope.onFroniusChange = function (systemSize) {
                                $scope.fnFronius(systemSize)
                            }
                            $scope.onLGChange = function (systemSize) {
                                $scope.fnLG(systemSize)
                            }
                        }

                        var noOfPoepleTemp = '1-2'
                        //Default kW choice
                        switch ($scope.data.HouseholdSize) {
                            case 'Small household':
                                defaultkWSize = 1.5
                                noOfPoepleTemp = '1-2'
                                break
                            case 'Average household':
                                defaultkWSize = 3
                                noOfPoepleTemp = '3-4'
                                break
                            case 'Large household':
                                defaultkWSize = 5
                                noOfPoepleTemp = '4+'
                                break
                            default:
                                break
                        }

                        $scope.selectedHouseholdData = $filter('filter')($scope.data.householdData, {
                            KWSystemInt: defaultkWSize,
                            SystemType: 'Solar'
                        })[0]
                        $scope.selectedHouseholdDataForLG = $filter('filter')($scope.data.householdData, {
                            KWSystemInt: $scope.ctrl.LGSystemSize,
                            SystemType: 'LG'
                        })[0]
                        $scope.selectedHouseholdDataForFronius = $filter('filter')($scope.data.householdData, {
                            KWSystemInt: $scope.ctrl.FroniusSystemSize,
                            SystemType: 'Fronius'
                        })[0]
                        $scope.result = {}

                        $scope.result.KWSystem = $scope.selectedHouseholdData.KWSystem
                        $scope.ctrl.solarSystemSize = defaultkWSize
                        $scope.result.EstimatedPriceRange = $scope.selectedHouseholdData.EstimatedPriceRange
                        $scope.result.PanelsNo = $scope.selectedHouseholdData.PanelsNo
                        $scope.result.PanelsNoInt = $scope.selectedHouseholdData.PanelsNoInt
                        $scope.result.RoofSpace = $scope.selectedHouseholdData.RoofSpace
                        $scope.result.SavingsPerYear = $scope.selectedHouseholdData.SavingsPerYear
                        $scope.result.Payback = $scope.selectedHouseholdData.Payback
                        $scope.result.noOfPoeple = noOfPoepleTemp
                        $scope.result.BatteryType = $scope.showBattery ? $scope.checkedTab : ''
                        $scope.selectedHouseholdDataForBattery =
                            $scope.checkedTab == 'LG'
                                ? $scope.selectedHouseholdDataForLG
                                : $scope.selectedHouseholdDataForFronius

                        if ($scope.selectedHouseholdDataForBattery) {
                            $scope.result.KWHSystemBattery = $scope.selectedHouseholdDataForBattery.KWSystem
                            $scope.result.BatteryEstimatedPriceRange = $scope.showBattery
                                ? $scope.selectedHouseholdDataForBattery.EstimatedPriceRange
                                : '0-0'
                            $scope.result.BatterySavingsPerYear = $scope.showBattery
                                ? $scope.selectedHouseholdDataForBattery.SavingsPerYear
                                : '0'
                        } else {
                            $scope.result.KWHSystemBattery = defaultBatterySize
                            $scope.result.BatteryEstimatedPriceRange = '0-0'
                            $scope.result.BatterySavingsPerYear = '0'
                            $scope.selectedHouseholdDataForBattery.Payback = '0'
                        }
                        $scope.result.totalSavings = addAmount(
                            $scope.result.BatterySavingsPerYear,
                            $scope.result.SavingsPerYear
                        )
                        var solarArray = $scope.result.EstimatedPriceRange.split('-')
                        var batteryArray = $scope.result.BatteryEstimatedPriceRange.split('-')
                        $scope.result.totalCost =
                            String(addAmount(solarArray[0], batteryArray[0])) +
                            ' - ' +
                            addAmount(solarArray[1], batteryArray[1])
                        $scope.result.HouseholdSize = $scope.data.HouseholdSize
                        $scope.result.EmailAddress =
                            $scope.data.EmailAddress !== undefined ? $scope.data.EmailAddress : ''
                        $scope.result.Address = $scope.data.installationAddress
                        $scope.data.SuburbExtract - $scope.data.postalCode
                        if ($scope.checkedTab == 'LG') {
                            $scope.fnLG($scope.ctrl.LGSystemSize)
                        } else {
                            $scope.fnFronius($scope.ctrl.FroniusSystemSize)
                        }
                        updateResultInCookies()
                    },
                    function (response) {
                        $scope.data.householdData = response.data
                    }
                )
            }

            $scope.HouseHoldchange = function () {
                //Do nothing
            }

            $scope.calculate = function (form) {
                $scope.submitted = true
                $scope.hasErrors = false
                //Check if form is valid
                if (form && !form.$valid) {
                    angular.forEach(form.$error.required, function (field) {
                        field.$setDirty()
                    })
                    $scope.submitted = false
                    $scope.hasErrors = true
                    return false
                }

                $scope.getHouseHoldDataUpdateResults()
            }

            $scope.$watch(
                function () {
                    return $scope.data.resultEmail
                },
                function (newValue) {
                    $rootScope.emailAddress = newValue
                    var jsonData = getDataFromCookies()

                    if (jsonData == null) {
                        jsonData = {}
                    }
                    jsonData.resultEmail = newValue
                    SolarComService.setCookieByName('sy_solar_battery_data', angular.toJson(jsonData))
                }
            )

            $scope.sendingEmail = false
            $scope.sendResultEmail = function () {
                $scope.actionURL = '/SolarBatteryCalculator/sendResultEmail'

                var config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                    }
                }

                var params = $scope.result
                params.EmailAddress = $scope.data.resultEmail
                params.connectionAddress = $scope.data.installationAddress
                params.AirConHours = $scope.selecteAirConHours
                params.siteUrl = $location.protocol() + '://' + $location.host()

                Object.keys(params).forEach(function (key) {
                    if (params[key] == '' || params[key] == undefined) {
                        delete params[key]
                    }
                })

                var params = Object.keys(params)
                    .map(function (k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
                    })
                    .join('&')

                $scope.sendingEmail = true
                $scope.emailSent = false
                $http.post($scope.actionURL, params, config).then(
                    function () {
                        $scope.sendingEmail = false
                        $scope.emailSent = true
                    },
                    function () {
                        $scope.sendingEmail = false
                    }
                )
            }
        }
    ])

    .directive('syChangeTabSelection', [
        '$timeout',
        '$location',
        '$anchorScroll',
        function syChangeTabSelection($timeout, $location, $anchorScroll) {
            return {
                restrict: 'A',
                link: function ($scope, elem, attrs) {
                    elem.bind('click', function () {
                        $timeout(function () {
                            $scope.checkedTab = attrs.href.replace('#', '')
                            $location.hash($scope.checkedTab)
                            $anchorScroll()
                        }, 0)
                    })
                }
            }
        }
    ])

    .directive('syGoToBatteryForm', [
        '$timeout',
        '$location',
        '$anchorScroll',
        function syGoToBatteryForm($timeout, $location, $anchorScroll) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function () {
                        $timeout(function () {
                            $location.hash('battery')
                            $anchorScroll()
                        }, 0)
                    })
                }
            }
        }
    ])

    .directive('sySolarCalcShow', [
        '$timeout',
        'SliderService',
        '$window',
        function sySolarCalcShow($timeout, SliderService, $window) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function (e) {
                        $timeout(function () {
                            if ($scope.submitted) {
                                var wi = $window.innerWidth
                                if (wi < 1139) {
                                    angular
                                        .element(document.querySelectorAll('.mobile-hide-fields'))
                                        .addClass('mobile-display-none')
                                    angular
                                        .element(document.querySelectorAll('.map-area'))
                                        .addClass('map-area-mobile-hidden')
                                    angular
                                        .element(document.querySelectorAll('.mobile-show-fields'))
                                        .addClass('mobile-display-none')
                                    angular
                                        .element(document.querySelectorAll('.savingscontainer'))
                                        .addClass('mobile-display-none')
                                }

                                var dc = angular.element(document.querySelector('#SBCContainer'))
                                SliderService.slideDownTransition(dc)
                                dc = angular.element(document.querySelector('#Map_field_container'))

                                if (wi < 1139) {
                                    SliderService.slideUpTransition(dc)
                                } else {
                                    SliderService.slideDownTransition(dc)
                                }
                                dc = angular.element(document.querySelector('#BCFloatingResult'))
                                if (wi < 1139) {
                                    SliderService.slideDownTransition(dc)
                                } else {
                                    SliderService.slideUpTransition(dc)
                                }

                                dc = angular.element(document.querySelector('.web_sticky'))
                                dc.removeClass('stuck')

                                dc = angular.element(document.querySelector('.mobile_sticky'))
                                dc.removeClass('stuck')
                                if (wi < 1139) {
                                    $window.scrollTo(0, 0)
                                } else {
                                    $window.scrollTo(0, 100)
                                }

                                $timeout(function () {
                                    $scope.$broadcast('rzSliderForceRender')
                                })
                            }
                        }, 100)
                    })
                }
            }
        }
    ])

    .directive('sySolarCalcMobileShow', [
        '$timeout',
        '$window',
        function sySolarCalcMobileShow($timeout, $window) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function (e) {
                        $timeout(function () {
                            if ($scope.submitted) {
                                var wi = $window.innerWidth
                                if (wi < 1139) {
                                    angular
                                        .element(document.querySelectorAll('.mobile-hide-fields'))
                                        .removeClass('mobile-display-none')
                                    angular
                                        .element(document.querySelectorAll('.map-area'))
                                        .removeClass('map-area-mobile-hidden')
                                    angular
                                        .element(document.querySelectorAll('.mobile-show-fields'))
                                        .removeClass('mobile-display-none')
                                }
                            }
                        }, 100)
                    })
                }
            }
        }
    ])

    .directive('sySolarCalcHide', [
        '$timeout',
        'SliderService',
        function sySolarCalcHide($timeout, SliderService) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function () {
                        $timeout(function () {
                            var dc = angular.element(document.querySelector('#SBCContainer'))
                            SliderService.slideUpTransition(dc)
                            dc = angular.element(document.querySelector('#Map_field_container'))
                            SliderService.slideUpTransition(dc)
                            dc = angular.element(document.querySelector('#BCFloatingResult'))
                            SliderService.slideDownTransition(dc)
                        }, 0)
                    })
                }
            }
        }
    ])

    .directive('sySolarCalcResultShowMobile', [
        '$timeout',
        'SliderService',
        '$window',
        function sySolarCalcResultShowMobile($timeout, SliderService, $window) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function () {
                        $timeout(function () {
                            angular
                                .element(document.querySelectorAll('.savingscontainer'))
                                .removeClass('mobile-display-none')

                            var dc = angular.element(document.querySelector('#SBCContainer'))
                            SliderService.slideDownTransition(dc)

                            dc = angular.element(document.querySelector('#Map_field_container'))
                            SliderService.slideDownTransition(dc)

                            dc = angular.element(document.querySelector('#BCFloatingResult'))
                            SliderService.slideUpTransition(dc)
                            dc = angular.element(document.querySelector('.mobile_sticky'))
                            dc.removeClass('stuck')
                            $window.scrollTo(0, 100)
                        }, 0)
                    })
                }
            }
        }
    ])

    .directive('sySolarBatteryCalcHouseholdSize', [
        function sySolarBatteryCalcHouseholdSize() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, elem, attrs) {
                    $scope.$watch(attrs.ngModel, function (newValue) {
                        if (newValue) {
                            $scope.$parent.data.HouseholdSize = newValue
                        }
                    })
                }
            }
        }
    ])

    .directive('sySizeRadio', [
        '$timeout',
        function sySizeRadio($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('focus', function (e) {
                        $timeout(function () {
                            $scope.data.noPeople = e.currentTarget.children[0].attributes.value.value
                            $scope.$apply()
                        }, 1000)
                    })
                }
            }
        }
    ])

    .directive('syBatteryTabs', [
        'AnalyticsService',
        function AnalyticsService() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, elem, attrs) {
                    $scope.$watch(attrs.ngModel, function (newValue) {
                        if (newValue) {
                            //Do nothing
                        }
                    })
                }
            }
        }
    ])

    .directive('sySearchAddressDefault', [
        '$rootScope',
        function sySearchAddressDefault($rootScope) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, $element, attrs, ngModel) {
                    $scope.searchAddressPaceholder = ''
                    $scope.searchStreetPlaceHolder = ''

                    $scope.$watch(
                        function () {
                            return $rootScope.installationAddress
                        },
                        function () {
                            $scope.data.search = $scope.searchAddressPaceholder = $rootScope.installationAddress
                            if ($rootScope.completeAddress && $rootScope.installationAddress) {
                                $scope.data.city = $scope.data.searchCityPlaceHolder = $rootScope.completeAddress.city
                                $scope.data.postalCode = $scope.data.searchPostcodePlaceHolder =
                                    $rootScope.completeAddress.postalCode
                                $scope.data.street = $scope.data.searchStreetPlaceHolder =
                                    $rootScope.completeAddress.street
                            }
                        }
                    )

                    // TODO: To be merged into MK code
                    $scope.$watch(
                        function () {
                            return ngModel.$modelValue
                        },
                        function (value) {
                            if (!value) {
                                $scope.data.city = undefined
                                $scope.data.postalCode = undefined
                                $scope.data.street = undefined
                            }
                        }
                    )
                }
            }
        }
    ])

    .directive('optionsClass', function optionsClass($parse) {
        return {
            require: 'select',
            link: function (scope, elem, attrs) {
                var match = attrs.ngOptions.split(' for '),
                    map = match[0],
                    src = match[1],
                    getOptionsAttrs = $parse(map)
                scope.$watchCollection(src, function () {
                    angular.forEach(elem.find('option'), function (option) {
                        angular.forEach(getOptionsAttrs(option), function (val, name) {
                            angular.element(option).attr(name, val)
                        })
                    })
                })
            }
        }
    })

    .directive('sticky', [
        '$window',
        function ($window) {
            return {
                link: function (scope, element, attrs) {
                    var $win = angular.element($window)

                    var scrollTop = function () {
                        if ($win.pageYOffset == undefined && $win[0].pageYOffset !== undefined) {
                            return $win[0].pageYOffset
                        }

                        return $win.pageYOffset !== undefined
                            ? $win.pageYOffset
                            : (document.documentElement || document.body.parentNode || document.body).scrollTop
                    }

                    if (scope._stickyElements === undefined) {
                        scope._stickyElements = []

                        var as = element.find('a')
                        var aCloseEl = angular.element(as)

                        aCloseEl.bind('click', function (e) {
                            e.target.style.display = 'none'

                            for (var i = 0; i < scope._stickyElements.length; i++) {
                                item.element.removeClass('stuck')
                                item.stickMe = false
                            }
                        })

                        $win.bind('scroll', function (e) {
                            var dc = angular.element(document.querySelector('#BCFloatingResult'))
                            if (dc.hasClass('height-transition-hidden')) {
                                return
                            }

                            var pos = scrollTop()
                            for (var i = 0; i < scope._stickyElements.length; i++) {
                                var item = scope._stickyElements[i]

                                if (!item.isStuck && pos > item.start && item.stickMe) {
                                    item.element.addClass('stuck')

                                    var ds = document.querySelectorAll('.close_wrap')
                                    for (var i = 0; i < ds.length; i++) {
                                        angular.element(ds[i]).css('display', 'block')
                                    }
                                    item.isStuck = true
                                } else if (item.isStuck && pos < item.start) {
                                    item.element.removeClass('stuck')
                                    angular.element(document.querySelector('.close_wrap')).css('display', 'none')
                                    item.isStuck = false
                                }
                            }
                        })

                        var recheckPositions = function () {
                            for (var i = 0; i < scope._stickyElements.length; i++) {
                                var item = scope._stickyElements[i]
                                if (!item.isStuck) {
                                    item.start = item.element[0].offsetTop
                                }
                            }
                        }
                        $win.bind('load', recheckPositions)
                        $win.bind('resize', recheckPositions)
                    }

                    var item = {
                        element: element,
                        isStuck: false,
                        placeholder: attrs.usePlaceholder !== undefined,
                        start: 160, // Element[0].offsetTop,
                        stickMe: true
                    }

                    scope._stickyElements.push(item)
                }
            }
        }
    ])

    .directive('sySolarCalcShowFocus', [
        '$timeout',
        'SliderService',
        '$window',
        function ($timeout, SliderService, $window) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {
                    elem.bind('click', function (e) {
                        $timeout(function () {
                            if ($scope.submitted) {
                                var wi = $window.innerWidth
                                if (wi < 1139) {
                                    angular
                                        .element(document.querySelectorAll('.mobile-hide-fields'))
                                        .addClass('mobile-display-none')
                                    angular
                                        .element(document.querySelectorAll('.map-area'))
                                        .addClass('map-area-mobile-hidden')
                                    angular
                                        .element(document.querySelectorAll('.mobile-show-fields'))
                                        .addClass('mobile-display-none')
                                    angular
                                        .element(document.querySelectorAll('.savingscontainer'))
                                        .addClass('mobile-display-none')
                                }

                                var dc = angular.element(document.querySelector('#SBCContainer'))
                                SliderService.slideDownTransition(dc)
                                dc = angular.element(document.querySelector('#Map_field_container'))

                                if (wi < 1139) {
                                    SliderService.slideUpTransition(dc)
                                } else {
                                    SliderService.slideDownTransition(dc)
                                }
                                dc = angular.element(document.querySelector('#BCFloatingResult'))
                                if (wi < 1139) {
                                    SliderService.slideDownTransition(dc)
                                } else {
                                    SliderService.slideUpTransition(dc)
                                }

                                dc = angular.element(document.querySelector('.web_sticky'))
                                dc.removeClass('stuck')
                                $('.site-search-input').css({ 'z-index': '5' })
                                $('.site-search-submit').css({ 'z-index': '6' })
                                dc = angular.element(document.querySelector('.mobile_sticky'))
                                dc.removeClass('stuck')
                                $timeout(function () {
                                    $scope.$broadcast('rzSliderForceRender')
                                })
                            }
                        }, 100)
                    })
                }
            }
        }
    ])

    .directive('sySolarCalcNoHide', [
        '$timeout',
        'SliderService',
        function ($timeout, SliderService) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    element.bind('click', function () {
                        $timeout(function () {
                            var dc = angular.element(document.querySelector('#SBCContainer'))
                            SliderService.slideUpTransition(dc)
                            dc = angular.element(document.querySelector('#BCFloatingResult'))
                            SliderService.slideDownTransition(dc)
                            $('.web_sticky').addClass('stuck')
                        }, 0)
                    })
                }
            }
        }
    ])
